/* ==================================================================
   MORII — stable section anchors
   ------------------------------------------------------------------
   Problem this solves:
   The homepage hero's second button ("Visit us") links to the tea
   house section by its Shopify section id, e.g.
     /#shopify-section-template--18715687256199__custom_liquid_qyxcwp
   Shopify regenerates that id every time the theme is duplicated, so
   the button silently scrolls nowhere on every copy of the theme.

   What this does:
   1. Gives the tea house section a permanent id: #morii-teahouse
   2. Repoints any legacy section-id link at it

   Result: the link keeps working no matter how often the theme is
   duplicated, and you can safely set the button link to
   "/#morii-teahouse" in the theme editor.

   To anchor another section the same way, add it to SECTIONS below
   using the section's suffix (the part after the "__").
   ================================================================== */

(function () {
  var SECTIONS = [{ suffix: '__custom_liquid_qyxcwp', anchor: 'morii-teahouse' }];

  function stabilise() {
    SECTIONS.forEach(function (entry) {
      var section = document.querySelector(
        '[id*="shopify-section"][id$="' + entry.suffix + '"]'
      );
      if (!section) return;

      // Prefer the inner content wrapper so the heading is not hidden
      // under the sticky header when the browser jumps to it.
      var target = section.querySelector('.morii-th') || section;
      if (!document.getElementById(entry.anchor)) {
        target.id = entry.anchor;
      }
      target.style.scrollMarginTop = '96px';

      // Repoint legacy links that still use the generated section id.
      var legacy = document.querySelectorAll('a[href*="' + entry.suffix + '"]');
      for (var i = 0; i < legacy.length; i++) {
        legacy[i].setAttribute('href', '#' + entry.anchor);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', stabilise);
  } else {
    stabilise();
  }

  // Re-run inside the theme editor, where sections re-render on edit.
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', stabilise);
  }
})();